import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AppEventDispatcher } from './../../../utils/AppEventDispatcher';
import { AutenticationEventType } from '../../autentication.event.type';
import { TweenMax, Quint, Sine } from 'gsap';

@Component({
	selector: 'app-security-check-registration-info',
	templateUrl: './info.component.html',
	styleUrls: ['./info.component.styl'],
	encapsulation: ViewEncapsulation.None
})
	export class InfoComponent implements OnInit {

	view = '[data-component="security-check-registration-info"]';
	active = false;
	loading = false;

	constructor() { }

	ngOnInit() {

		AppEventDispatcher.listen(AutenticationEventType.SECURITY_CHECK_REGISTRATION.INFO, (data: any) => {
			if (data.show) {
				this.active = true;
			}
		});
	}

	hide() {
		this.loading = true;
		AppEventDispatcher.dispatch(AutenticationEventType.SECURITY_CHECK_REGISTRATION.REGISTRATION, { show: true });
		this.active = false;
		this.loading = false;
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/autentication/security-check-registration/info/info.component.ts